
import { computed, defineComponent, PropType } from "vue";
import { OptionsClass } from "@/domain/entities/MainApp";
import { MessageConfVariables } from "@/domain/entities/MessagingServiceConfiguration";
import { MessagingServiceConfigurationController } from "@/app/ui/controllers/MessagingServiceConfigurationController";

export default defineComponent({
  name: "MessageVariables",
  emits: ["update:modelValue", "openDictionary"],
  props: {
    modelValue: {
      type: Array as PropType<MessageConfVariables[]>,
      default: () => [] as MessageConfVariables[]
    },
    detail: {
      type: Boolean,
      default: false
    },
    tableFontSize: {
      type: String,
      default: "text-sm"
    }
  },
  setup(props, { emit }) {
    // ✅ reactive bridge for v-model
    const data = computed<MessageConfVariables[]>({
      get: () => props.modelValue,
      set: (value: MessageConfVariables[]) => emit("update:modelValue", value)
    });

    // Methods
    const onDelete = (index: number) => {
      data.value.splice(index, 1);
    };

    const onAdd = () => {
      data.value.push(new MessageConfVariables());
    };

    const showDictionary = () => {
      emit("openDictionary");
    };

    // Computed
    const listValue = computed(() =>
      MessagingServiceConfigurationController.messageDictionary.tagDefinition.map(
        (item) => {
          const tag = item.tag.replace(/[{}]/g, "");
          return new OptionsClass({ name: tag, value: tag });
        }
      )
    );

    return {
      data,
      listValue,
      onDelete,
      onAdd,
      showDictionary
    };
  }
});
